import { render, staticRenderFns } from "./Section9.vue?vue&type=template&id=135ec2a9&scoped=true&"
import script from "./Section9.vue?vue&type=script&lang=js&"
export * from "./Section9.vue?vue&type=script&lang=js&"
import style0 from "./Section9.vue?vue&type=style&index=0&id=135ec2a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135ec2a9",
  null
  
)

export default component.exports